import { IconWrapper } from '../runtime';
export default IconWrapper('add-left', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.25 5.49976V10.4998M6.75 7.99976H1.75M9.75 3.49976C9.75 2.67133 10.4216 1.99976 11.25 1.99976H12.75C13.5784 1.99976 14.25 2.67133 14.25 3.49976V12.4998C14.25 13.3282 13.5784 13.9998 12.75 13.9998H11.25C10.4216 13.9998 9.75 13.3282 9.75 12.4998V3.49976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});